<template>
  <div class="custom-radio-button mt-1" style="height: 30px;">
    <span @click="decrement">-</span>
    <input type="text" class="text-center custom-input" :value="this.value" name="quantity">
    <span @click="increment">+</span>
  </div>
</template>

<script>
export default {
  props: {
    initialValue: Number,
  },
  data: function () {
    return {
      value: 1,
    }
  },
  methods: {
    increment() {
      this.value += 1;
    },
    decrement() {
      if (this.value > 1) {
        this.value -= 1;
      }
    }
  },
  mounted() {
    if (this.initialValue) {
      this.value = this.initialValue;
    }
  }
}
</script>

<style scoped>

</style>
